export default "__VITE_ASSET__jE9e_lIh__"